import { useState } from 'react';

import { useNavigate } from 'react-router-dom';

import PropTypes from 'prop-types';
import { BsPlus, BsBrilliance } from 'react-icons/bs';

import Modal from '#globalComponents/Overlay/Modal';
import Panel from '#globalComponents/Overlay/Panel';

import ManualPipelineForm from './ManualPipelineForm';

/**
 * Modal for creating a new pipeline. Two modes:
 *   1) Manual — user defines name + stages themselves (ManualPipelineForm)
 *   2) AI-Onboarding — redirects to /crm/onboarding for AI-generated pipeline
 */

const NewPipelineModal = ({ isOpen, onClose }) => {
	const [mode, setMode] = useState(null); // null = choose, 'manual' = form, 'ai' = redirect

	const navigate = useNavigate();

	const handleGoToOnboarding = () => {
		onClose();
		navigate('/crm/onboarding');
	};

	// Step 1: Choose mode
	if (mode === null) {
		return (
			<Modal isOpen={isOpen} onClose={onClose} size="s">
				<Panel.Header onClose={onClose} subtitle="Wie möchten Sie Ihre Pipeline aufbauen?">
					Neue Pipeline erstellen
				</Panel.Header>
				<Panel.Body className="space-y-4">
					<button
						type="button"
						onClick={() => setMode('manual')}
						className="w-full text-left rounded-card border border-bgBase-500 p-4 hover:border-primary-300 hover:bg-primary-100/30 transition-colors"
					>
						<div className="flex items-center gap-3">
							<div className="h-10 w-10 rounded-full bg-bgBase-400 flex items-center justify-center flex-shrink-0">
								<BsPlus className="w-5 h-5 text-text" />
							</div>
							<div>
								<p className="text-sm font-semibold text-text">Manuell erstellen</p>
								<p className="text-xs text-bgBase-800 mt-0.5">Definiere Name und Stages selbst</p>
							</div>
						</div>
					</button>

					<button
						type="button"
						onClick={handleGoToOnboarding}
						className="w-full text-left rounded-card border border-bgBase-500 p-4 hover:border-primary-300 hover:bg-primary-100/30 transition-colors"
					>
						<div className="flex items-center gap-3">
							<div className="h-10 w-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
								<BsBrilliance className="w-5 h-5 text-primary-600" />
							</div>
							<div>
								<p className="text-sm font-semibold text-text">KI-Assistent nutzen</p>
								<p className="text-xs text-bgBase-800 mt-0.5">
									Beantworte ein paar Fragen und die KI erstellt eine passende Pipeline
								</p>
							</div>
						</div>
					</button>
				</Panel.Body>
			</Modal>
		);
	}

	// Step 2: Manual form
	return (
		<Modal isOpen={isOpen} onClose={onClose} size="m">
			<ManualPipelineForm onCreated={onClose} onBack={() => setMode(null)} />
		</Modal>
	);
};

NewPipelineModal.propTypes = {
	isOpen: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
};

export default NewPipelineModal;
